import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import TruckOutlinedSvg from "@ant-design/icons-svg/es/asn/TruckOutlined";
import AntdIcon from "../components/AntdIcon";
var TruckOutlined = function TruckOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: TruckOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  TruckOutlined.displayName = 'TruckOutlined';
}
export default /*#__PURE__*/React.forwardRef(TruckOutlined);